// extracted by mini-css-extract-plugin
module.exports = {"root":"_23czo2d","icon":"_1FYpYKG","iconOpen":"_3xo1yDx"};